import type { ReactElement } from "react";

import { FormFieldLabel } from "app/pages/sales-intelligence/common-components/form-fields";
import type { IRange } from "app/pages/sales-intelligence/types/range";

import type { IFilterViewBaseModelProps } from "../../../types/filterInstance";
import type { DynamicNumberRangeOptions } from "../../../types/filterOptions";
import RangeSelectWithClear from "../RangeSelectFilter/RangeSelectWithClear";

const NumberRangeFilter = ({
    filter: {
        options: { label, fieldName, buckets, placeholderPrefix, formatValue },
    },
    value,
    isTopLayer,
    onFilterUpdate,
}: IFilterViewBaseModelProps<Partial<IRange<number>>, DynamicNumberRangeOptions>): ReactElement => {
    const handleChange = ([from, to]: readonly number[]): void => onFilterUpdate({ from, to });

    const clearSelection = (): void => onFilterUpdate();

    const content = (
        <div data-automation="number-range-filter">
            <RangeSelectWithClear
                fieldName={fieldName}
                value={value}
                buckets={buckets}
                formatValue={formatValue}
                placeholderPrefix={placeholderPrefix}
                isTopLayer={isTopLayer}
                onChange={handleChange}
                onClear={clearSelection}
            />
        </div>
    );

    return label ? <FormFieldLabel text={label}>{content}</FormFieldLabel> : content;
};

export default NumberRangeFilter;
